// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

/**
 * Query key factory for @tanstack/react-query cache management.
 *
 * Follows the query key factory pattern so that cache invalidation
 * can target all queries for a collection, a specific query shape,
 * or a single document.
 */

import type { D1QueryParams } from './d1Client'

export const collectionKeys = {
  all:    (name: string) => [name] as const,
  query:  (name: string, params: D1QueryParams) => [name, 'query', params] as const,
  get:    (name: string, ids: string[]) => [name, 'get', ids] as const,
  single: (name: string, id: string) => [name, 'single', id] as const,
}
